module.exports = __webpack_public_path__ + "img/img-creditcard-sec-03-01.png";